import { render, staticRenderFns } from "./ttSetting.vue?vue&type=template&id=689587a4&"
import script from "./ttSetting.vue?vue&type=script&lang=js&"
export * from "./ttSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports